import type { DeepRequired } from '../fixtures.types'

const document: DeepRequired<DocumentEntity> = {
  __typename: 'DocumentEntity',
  archived: null,
  case_ids: [],
  cases: [],
  data_base64: null,
  date_stored: null,
  document_date: null,
  document_expiry: null,
  document_id: null,
  document_name: null,
  document_object_reference: null,
  document_signature: null,
  file_type: null,
  general_insurance_product_id: null,
  metadata: null,
  mortgageStatus: null,
  origination_fingerprint: null,
  other_type: null,
  owning_client_ids: [],
  owning_clients: [],
  rendered_case_ids: [],
  rendered_cases: [],
  rendered_client_ids: [],
  rendered_clients: [],
  rendered_compliance_email_recipients: [],
  rendered_compliance_email_subject: null,
  rendered_mortgage_ids: [],
  rendered_mortgages: [],
  rendered_organisation_ids: [],
  rendered_organisations: [],
  rendered_product_ids: [],
  rendered_products: [],
  rendered_user_ids: [],
  rendered_users: [],
  signature_key_id: null,
  signed_copy: null,
  source: null,
  source_client: null,
  source_client_id: null,
  source_user: null,
  source_user_id: null,
  tags: [],
  template: null,
  template_id: null,
  template_type: null,
  type: null,
  uploaded_by: null,
  verification_count: null,
  verifications: [],
  internalHash: null,
}

export default document
